import React, { useState, useEffect } from 'react';

import { FaEdit } from "react-icons/fa";
import { FaTimesCircle } from "react-icons/fa";
import { FaCheckCircle } from "react-icons/fa";
import { useSelector } from 'react-redux';


const TecogisAdmin = () => {

  const [searchTerm, setSearchTerm] = useState("");
  // Access the persisted user data from Redux store
  const user = useSelector((state) => state.auth.user);
  const selectedEvent = useSelector((state) => state.auth.selectedEvent);

  return (
    <div className='container-fluid'>
        <div className="occasion-top d-flex justify-content-between  align-items-center">
          <h2>Tecogis Admin</h2>
          <div style={{ maxWidth: '300px', width: '100%' }}>
              <input type="text" className="form-control mb-3"  placeholder="Search occasions..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
          </div>
        </div>
        <div className='row'>
          <div className='col-lg-12'>
            <div className='form-section'>
                <form>
                    <div className="row">
                        <div className='col-md-4'>
                          <label className="form-label"><span className="required">*</span>Admin Name</label>
                          <input type="text" className="form-control" id="floatingInput" placeholder="name@example.com" />
                        </div>
                        <div className='col-md-4'>
                            <label className="form-label"><span className="required">*</span>Login Name</label>
                            <input type="text" className="form-control" id="floatingPassword" placeholder="Password" />
                        </div>
                        <div className='col-md-4'>
                            <label className="form-label"><span className="required">*</span>Password</label>
                            <input type="text" className="form-control" id="floatingPassword" placeholder="Password" />
                        </div>
                    </div>
                    {/* <hr /> */}
                    <div className="mt-4 d-flex justify-content-end gap-2 justify-content-center py-5">
                      <button type="submit" className="btn btn-success btn-save">Save</button>
                      <button type="reset" className="btn btn-outline-secondary btn-cancel">Cancel</button>
                    </div>
                </form>
            </div>
          </div>

          {/* Left Section */}
          {/* <div className="col-lg-3">
            <div className="occasion-list">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6 className="mb-2 event-inner-hed">Tecogis</h6>
                </div>
            </div>
          </div> */}

        </div>

           <div className="dashboard-container">
      {user ? (
        <>
          <h4>User Info:</h4>
          <p>Name: {user.name}</p>
          <p>Email: {user.email}</p>
          <p>isAdmin: {user.isAdmin ? "Yes" : "No"}</p>
          <p>isSuperAdmin: {user.isSuperAdmin ? "Yes" : "No"}</p>
          <p>isActive: {user.isActive ? "Yes" : "No"}</p>
          <p>Role: {user.role }</p>

          {selectedEvent ? (
            <>
              <h4>Selected Event Info:</h4>
              <p>Event Name: {selectedEvent.eventName}</p>
              <p>Event ID: {selectedEvent.eventId}</p>
              <p>Is Admin for Event: {selectedEvent.isAdmin ? "Yes" : "No"}</p>
              <p>Is Event Active: {selectedEvent.isEventActive ? "Yes" : "No"}</p>
            </>
          ) : (
            <p>No event selected</p>
          )}
        </>
      ) : (
        <p>No user information available</p>
      )}
    </div>

        <div className='form-section my-5'>
          <div className='row'>
            <div className='col-xl-12'>
              <div className='table-responsive table-bordered'>
                <table className='table table-striped table-border  table-hover'>
                <thead className='table-dark'>
                  <tr>
                    <th>S. No.</th>
                    <th>Admin Name</th>
                    <th>Login Name</th>
                    <th>Password</th>
                    <th colSpan={"2"}>Action</th>
                  </tr>
                  </thead>
                  
                  <tbody>
                  <tr>
                    <td>1</td>
                    <td>Atul Dangi</td>
                    <td>Adangi</td>
                    <td>12345</td>
                    <td><FaEdit /> Edit</td>
                    <td><FaTimesCircle /> Activate</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>Atul Dangi</td>
                    <td>Adangi</td>
                    <td>12345</td>
                    <td><FaEdit /> Edit</td>
                    <td><FaCheckCircle /> Deactivate</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>Super Admin</td>
                    <td>Admin</td>
                    <td>7894</td>
                    <td><FaEdit /> Edit</td>
                    <td><FaCheckCircle /> Deactivate</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      
  </div>
    

  )
}

export default TecogisAdmin